<template>
  <div class="type-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button :icon="Plus" type="primary" @click="handleEdit($event)">添加</el-button>
      </vab-query-form-left-panel>

      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-select v-model="queryForm.articleCategoryId" clearable>
              <template v-for="(item, index) in categoryList" :key="index">
                <el-option :label="item.name" :value="item.id" />
              </template>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="企业:">
            <el-select
              v-model="queryForm.enterpriseCode"
              @change="queryData"
              clearable
            >
              <template v-for="(item, index) in enterPriseList" :key="index">
                <el-option
                  :value="item.enterpriseCode"
                  :label="item.enterpriseName"
                ></el-option>
              </template>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="内容名称" prop="title" show-overflow-tooltip />

      <el-table-column label="内容封面" show-overflow-tooltip>
        <template #default="{ row }">
          <el-image :src="row.coverUrl" />
        </template>
      </el-table-column>

      <el-table-column label="内容类型" prop="articleCategoryName" show-overflow-tooltip />

      <el-table-column label="内容状态" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-if="row.status == 'DRAFT'" type="info">草稿</el-tag>
          <el-tag v-else-if="row.status == 'PENDING_PUBLISH'" type="warning">待发布</el-tag>
          <el-tag v-else type="success">发布</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" show-overflow-tooltip width="185">
        <template #default="{ row }">
          <el-button type="primary" @click="handleEdit(row)">
            <vab-icon icon="edit-2-line" />
            编辑
          </el-button>
          <el-button type="danger" @click="handleDelete(row)">
            <vab-icon icon="delete-bin-6-line" />
            删除
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <!-- <edit ref="editRef" @fetch-data="fetchData" /> -->
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
    onDeactivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getArticleList, deleteArticle, getCategoryList } from '@/api/content'
  import { getUserEnterPriseAccount } from '@/api/user'
  export default defineComponent({
    name: 'ContentManage',
    components: {
      // Edit: defineAsyncComponent(() => import('./components/articleEdit')),
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        queryForm: {
          articleCategoryId: '',
          pageNum: 1,
          pageSize: 10,
          enterpriseCode: '',
        },
        total: 0,
        listLoading: false,
        list: [],
        layout: 'prev, pager, next',
        editRef: null,
        categoryList: [],
        enterPriseList: [],
      })

      const handleEdit = (row) => {
        if (row.articleId) {
          let query = {
            id: row.articleId,
          }
          if (state.queryForm.enterpriseCode) {
            query.enterpriseCode = state.queryForm.enterpriseCode
          }
          proxy.$router.push({
            path: `/contentCenter/articleEdit`,
            query,
          })
          // state.editRef.showEdit(row)
        } else {
          let query = {
            id: 'new',
          }
          if (state.queryForm.enterpriseCode) {
            query.enterpriseCode = state.queryForm.enterpriseCode
          }
          proxy.$router.push({
            path: `/contentCenter/articleEdit`,
            query,
          })
        }
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await deleteArticle({ id: row.id })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchEnterPrise = async () => {
        let userInfoData = JSON.parse(localStorage.getItem('userInfo'))
        console.log(userInfoData)
        let params = {
          tid: userInfoData.tid,
          iamUid: userInfoData.uid,
        }
        const { data: userInfo } = await getUserEnterPriseAccount(params)
        state.enterPriseList = userInfo
        // state.queryForm.enterpriseCode = userInfo[0].enterpriseCode
      }
      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getArticleList(state.queryForm)
        state.list = data.data
        state.total = data.total
        state.listLoading = false

        getCategoryList({ pageNum: 1, pageSize: 9999 }).then((res) => {
          state.categoryList = res.data.data
        })
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      onActivated(async () => {
        await fetchEnterPrise()
        await fetchData()
        console.log('我执行了')
      })

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        Delete,
        Search,
        Plus,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
